import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { useParams } from 'react-router-dom';
import * as R from 'ramda';

import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import {getUserInfoById, getOnboardingUserAddressesByUserId} from '../../../actions/facilita-api';
import { fetchPartnerCustomization } from './../../../actions/user-api';

import { LoadingState } from '../../../_common/loadingState';
import { Navbar } from './navbar';
import { Help } from './../_common/help';
import { Path } from './../_common/path';

import { Step1 } from './steps/step1';
import { Step2 } from './steps/step2';
import { Step3 } from './steps/step3';
import { Step4 } from './steps/step4';

export const Onboarding = ({user}) => {
  const dispatch = useDispatch();
  const deathDeclarationState = useSelector(state => state.deathDeclaration);
  const facilitaState = useSelector(state => state.facilita);
  const [loaded, setLoaded] = useState(false);

  const [partnerCustomization, setPartnerCustomization] = useState({
		isLoaded: false,
		logoBase64Encoded: undefined,
		color: undefined
	  });
  

  const [subsectionsStatuses, setSubsectionsStatuses] = useState({
    civilForm: false,
    familySituationForm: false,
    childrenForm: false,
    residenceForm: false,
    professionalSituationForm: false,
  });

  const [serviceSubsectionsStatuses, setServiceSubsectionsStatuses] = useState({
    demarchesCommunes: false,
    demarchesPersonalisee: false
  });

  const {userId} = useParams();

  useEffect(() => {
    dispatch(getUserInfoById(userId))
    .then(() => {
        dispatch(getOnboardingUserAddressesByUserId(userId)).then(() => setLoaded(true));
      }
    );
  }, [userId]);

  useEffect(() => {
    if(!R.isNil(deathDeclarationState.user.partnerId) && deathDeclarationState.user.partnerId !== '00000000-0000-0000-0000-000000000000'){
      fetchPartnerCustomization(deathDeclarationState.user.partnerId)
      .then((customization) => {
        if(!R.isNil(customization)){
          setPartnerCustomization({...customization, isLoaded: true});
        }
      })
      .catch(() => setPartnerCustomization({...partnerCustomization, isLoaded: true}))
    }else{
      setPartnerCustomization({...partnerCustomization, isLoaded: true})
    }
  }, [deathDeclarationState.user])


  

  if(!loaded){
    return (
    <article className="flex-column mb-auto h-100 scroll-default rounded">
        <LoadingState />
    </article>
    )
  }

  const deceasedUser = facilitaState.representing.find(r => r.id === userId);
  

  return (
    <div className={"layout layout-row" + (!R.isNil(partnerCustomization) && !R.isNil(partnerCustomization.color) && partnerCustomization.color !== "" ? "" : " bg-gradient-primary")} style={{backgroundColor: "rgb(113, 131, 107)" }}>
        <ToastContainer />
					<h1 className="sr-only visually-hidden">Assist@</h1>
      <Navbar user={facilitaState.user} deceasedUser={deathDeclarationState.user} subsectionsStatuses={subsectionsStatuses} serviceSubsectionsStatuses={serviceSubsectionsStatuses} partnerColor={partnerCustomization.color} logoContent={partnerCustomization.logoBase64Encoded} profilePicture={facilitaState.profilePicture} />
          <main role="main" className="view flex-grow-1 bg-gradient-light">
						<h1 className="sr-only visually-hidden">Assist@: Main</h1>
            <div className='container-fluid flex-md-row align-items-center gap-xs pt-3'>
              <Help row={true} />
              <Path deceasedUser={deceasedUser} declaration={deathDeclarationState.declaration} serviceDatas={deathDeclarationState.serviceDatas} userLetters={deathDeclarationState.userLetters} />							
            </div>
            <Switch>
              <Route path="/facilita/:userId/onboarding/step1">
                  <Step1 defaultPersonalData={deathDeclarationState.user} isLoading={deathDeclarationState.isLoading} setSubsectionsStatuses={setSubsectionsStatuses} subsectionsStatuses={subsectionsStatuses} />
              </Route>
              <Route path="/facilita/:userId/onboarding/step2">
                  <Step2 defaultPersonalData={deathDeclarationState.user} connectionTypes={deathDeclarationState.connectionTypes} isLoading={deathDeclarationState.isLoading} setSubsectionsStatuses={setServiceSubsectionsStatuses} subsectionsStatuses={serviceSubsectionsStatuses} />
              </Route>
              <Route path="/facilita/:userId/onboarding/step3">
                  <Step3 userId={deathDeclarationState.user.id} connectionTypes={deathDeclarationState.connectionTypes} isLoading={deathDeclarationState.isLoading} />
              </Route>
              <Route path="/facilita/:userId/onboarding/step4">
                  <Step4 user={deathDeclarationState.user} isLoading={deathDeclarationState.isLoading} referent={facilitaState.user} />
              </Route>
              <Route path="/facilita/:userId/onboarding" render={() => {
                      return <Redirect exact to={`/facilita/${userId}/onboarding/step1`} />
                }} />
            </Switch>
          </main>
    </div>
  )
}